import $ from "jquery";
import ko from "knockout";
import manifestManager from "flow/utils/manifestManager";
import componentCache from "flow/utils/componentCache";
import ajaxErrorHelper from "flow/ajax/ajaxErrorHelper";
import * as _ from "underscore";
import MyFlow from "flow/MyFlow";
import { Dictionary } from "flow/api/types";
import Component from "flow/Component";

export interface ICustomGroupMenuViewContext {
    functionType: string;
    title: string;
}

function CustomGroupMenu(myFlow: MyFlow) {
    const groups = ko.observableArray([]);
    const title = ko.observable();

    const isLoading = ko.pureComputed(function () {
        const anyGroupWithLoadingComponent = _.find(groups(), function (group) {
            const anyLoadingComponent = _.find(group.components(), function (component) {
                return component.isLoading ? component.isLoading() : false;
            });
            return anyLoadingComponent ? true : false;
        });
        return anyGroupWithLoadingComponent ? true : false;
    });

    function activate(viewContext: ICustomGroupMenuViewContext) {
        if (groups().length !== 0) {
            return;
        }

        const sortedGroups = [];

        const functionType = viewContext.functionType;
        title(myFlow.translate(viewContext.title));
        const manifests = manifestManager.getCustomGroupMenuManifests(functionType);

        for (let i = 0; i < manifests.length; i++) {
            let inserted = false;

            const group = {
                moduleId: manifests[i].moduleId,
                area: myFlow.translate(manifests[i].customGroupMenuItem.area),
                subMenuVisible: ko.observable(false),
                toggleSubMenuVisibility: function () {
                    this.subMenuVisible(!this.subMenuVisible());
                },
                components: ko.observableArray([])
            };

            const component = componentCache.getComponentByManifest(manifests[i]);

            if (sortedGroups.length > 0) {
                for (let j = 0; j < sortedGroups.length; j++) {
                    if (sortedGroups[j].area === myFlow.translate(manifests[i].customGroupMenuItem.area)) {
                        sortedGroups[j].components.push(component);
                        inserted = true;
                        break;
                    }
                }
                if (inserted === false) {
                    group.components.push(component);
                    sortedGroups.push(group);
                }
            } else {
                sortedGroups.push(group);
                sortedGroups[0].components.push(component);
            }
        }

        const language = myFlow.getCulture().split("-")[0];

        sortedGroups.sort(function (a, b) {
            return a.area.localeCompare(b.area, language);
        });

        if (sortedGroups.length === 1) {
            sortedGroups[0].subMenuVisible(true);
        }

        groups(sortedGroups);

        for (let n = 0; n < groups().length; n++) {
            const components = groups()[n].components();
            for (let p = 0; p < components.length; p++) {
                const current = components[p];
                const componentViewContext = $.extend({}, current.manifest.defaultParameters);
                current
                    .load()
                    .done(
                        function (component: Component, viewContext: Dictionary) {
                            component.activate(viewContext);
                            component.onShow();
                        }.bind(this, current, componentViewContext)
                    )
                    .fail(function (possibleJqXhr: JQuery.jqXHR) {
                        if (ajaxErrorHelper.isjqXhrObject(possibleJqXhr)) {
                            if (ajaxErrorHelper.isConnectionProblem(possibleJqXhr)) {
                                myFlow.handleAjaxError(possibleJqXhr);
                            }
                        }
                    });
            }
        }
    }

    function onHide() {
        for (let n = 0; n < groups().length; n++) {
            const components = groups()[n].components();
            for (let p = 0; p < components.length; p++) {
                components[p].onHide();
            }
        }
    }

    function onDestroy() {
        for (let n = 0; n < groups().length; n++) {
            const components = groups()[n].components();
            for (let p = 0; p < components.length; p++) {
                if (components[p].manifest.reuseInstance === false) {
                    components[p].onDestroy();
                }
            }
        }
    }

    return {
        activate: activate,
        groups: groups,
        title: title,
        onHide: onHide,
        onDestroy: onDestroy,
        isLoading: isLoading
    };
}

export default CustomGroupMenu;
